<template>
  <v-layout column>
    <v-toolbar flat dark color="primary">
      <v-toolbar-title>
        <span class="headline" v-if="this.user.userId == null"
          >Новый пользователь</span
        >
        <span class="headline" v-else>Редактирование пользователя</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn icon dark @click="cancelUser">
          <v-icon>{{ icons.close }}</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-form ref="form" v-model="valid">
      <v-card>
        <v-card-title></v-card-title>

        <v-card-text>
          <v-container>
            <v-text-field
              label="Электронная почта*"
              required
              placeholder="test@gmail.com"
              :rules="rules.email"
              v-model.trim="user.email"
              :disabled="this.user.userId != null"
            ></v-text-field>

            <v-text-field
              label="Пароль*"
              required
              name="password"
              :rules="rules.password"
              :append-icon="showPassword ? icons.eye : icons.eyeOff"
              :type="showPassword ? 'text' : 'password'"
              v-model.trim="user.password"
              @click:append="showPassword = !showPassword"
              v-if="this.user.userId == null"
            ></v-text-field>

            <v-text-field label="ФИО" v-model.trim="user.name"></v-text-field>

            <v-switch
              color="primary"
              :label="
                user.deleted
                  ? 'Активировать пользователя'
                  : 'Деактивировать пользователя'
              "
              :input-value="user.deleted"
              @change="deactivateUser"
              v-if="this.user.userId != null"
            ></v-switch>
          </v-container>
          <small>*указывает на обязательное поле</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined color="primary" @click="cancelUser">Отмена</v-btn>
          <v-btn dark color="primary" @click="saveUser">Сохранить</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-layout>
</template>

<script>
import { mapActions } from "vuex";

import { Icon } from "@/helpers";

export default {
  props: {
    user: Object,
  },
  methods: {
    ...mapActions({
      createChildUser: "users/CREATE_CHILD_USER",
      updateChildUser: "users/UPDATE_CHILD_USER",
    }),
    cancelUser: function () {
      this.$emit("cancel-user");
      this.$refs.form.resetValidation();
    },
    saveUser: function () {
      if (this.valid) {
        const currentUser = Object.assign({}, this.user);
        currentUser.deleted = this.deleteUser;

        if (currentUser && currentUser != null && currentUser.userId != null)
          this.updateChildUser(currentUser);
        else this.createChildUser(currentUser);

        this.$emit("save-user");
      }
    },
    deactivateUser: function (value) {
      this.deleteUser = value;
    },
  },
  data: () => ({
    valid: true,
    showPassword: false,
    rules: {
      email: [
        (v) => !!v || "Поле 'Электронная почта' обязательное",
        (v) =>
          /.+@.+\..+/.test(v) || "Поле 'Электронная почта' должно быть верным",
      ],
      password: [(v) => !!v || "Поле 'Пароль' обязательное"],
    },
    deleteUser: false,
    icons: {
      close: Icon.close,
      eye: Icon.eye,
      eyeOff: Icon.eyeOff,
    },
  }),
};
</script>
